<template>
  <section class="overview">
    <div class="overview__intro">
      <p>I am a Canadian arbitrator and mediator based in Calgary, Alberta experienced in the resolution of both domestic and international commercial disputes.</p>
    </div>
    <div class="overview__content">
      <div class="overview__content-image">
          <img src="../assets/overview.jpg" alt="Photo of Julie G. Hopkins" />
      </div>
      <div class="overview__content-text">
          <h2>Overview</h2>
          <p>I am an independent commercial arbitrator and mediator. Previously, I was counsel at Borden Ladner Gervais LLP where I practiced commercial litigation, arbitration and administrative law for more than 25 years, advising and representing clients on complex and technical issues.
          </p>
          <p>My experience spans a variety of industries including electricity generation and transmission, oil and gas (oilsands, pipelines and LNG), construction, aviation, trucking, real estate development, health care and cannabis. I have handled disputes involving shareholder, limited partnership, joint operating, joint venture, franchise, co-operation, asset purchase, cogeneration and maintenance agreements.
          </p>
          <p>As an arbitrator, I have experience with multi-party disputes and have been appointed to ad hoc, institutional, domestic and international arbitrations as sole arbitrator, chair and as co-arbitrator. I am on the rosters of a number of arbitral institutions including the CPR’s Panels of Distinguished Neutrals (Global Panel), ICDR Canada, and the Vancouver International Commercial Arbitration Centre (Domestic and International Panels).  In addition to sitting as an arbitrator, I was an adjudicator under the Canada Labour Code and a Panel Chair on the Alberta Insurance Councils Appeal Board for a number of years.
          </p>
          <p>I am a Fellow of the Chartered Institute of Arbitrators (“CIArb”) and Past Chair of the CIArb’s Canada Branch. I frequently served as one of the instructors of CIArb’s Accelerated Route to Fellowship Course which is designed for experienced dispute resolution professionals.
          </p>
      </div>
    </div>
    </section>
</template>

<script>
export default {
  name: 'Experience',
  props: {}
}
</script>

<style lang="scss" scoped>
.overview {

  &__intro {
    p {
      font-size: 1.5rem;
      font-weight: 350;
      text-align: left;
      padding: 0 1.5rem;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    &-image {
      width: 100%;
      .desktop-only {
        display: none;
      }

      img {
        width: 100%;
      }
    }
    
    &-text {
      padding: 3.5rem 1.5rem;
      text-align: left;

      h2 {
        font-family: 'Avenir', sans-serif;
        font-size: 1.75rem;
        font-weight: 800;
        line-height: 36px;
        margin-bottom: 0.75rem;
        
        &:before {
          top: -22px;
          background: $primary-accent;
          width: 90px;
        }
      }

      p {
        font-size: 1rem;
        font-weight: 350;
        line-height: normal;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

}

@media only screen and (min-width: 768px) {
  .overview {

    &__intro {
      margin: 0 auto;
      padding : 0 10% 0 10%;
      max-width: 90vw;

      p {
        font-size: 2rem;
        padding: 4.5rem 0;
        margin-bottom: 0;
      }
    }

    &__content {
      &-text {
        padding-top: 5.75rem;
        h2 {
          font-size: 2.5rem;
          line-height: 48px;
          &:before {
            top: -32px;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 1024px) {
  .overview {

    margin-bottom: 5.25rem;

    &__content {
      flex-direction: row;
      align-items: stretch;

      &-image,
      &-text {
        width: 50%;
      }

      &-text {
        padding-top: 2rem !important;
      }

      &-image {
        img {
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      &-text {
        padding: 0.75rem 10% 0 3.5rem;
      }
    }
  }
}
</style>
